"use client"; 
import { techData } from "@/data/tech";
import React from "react";
import { useTranslation } from "@/app/i18n/i18n-client";

export default function Tech({ locale, slug }) {
  const { t } = useTranslation(locale, "projects");


  // ✅ Find the tech data by slug
  const techItem = techData.find((item) => item.slug === slug);

 

  console.log("✅ Tech Data Found:", techItem);

  // ✅ Extract section title safely
  const sectionTitleKey = techItem.analysis?.sectionTitle || "";
  const sectionTitleTranslated = t(sectionTitleKey, `❌ Missing Title: ${sectionTitleKey}`);

  return (
    <div className="award-area-1 space overflow-hidden">
      <div className="container">
        <div className="title-area text-center">
          <h2 className="sec-title">{sectionTitleTranslated}</h2>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <ul className="award-wrap-area">
              {Object.entries(techItem.analysis).map(([key, value], index) => {
                if (key.startsWith("name")) {
                  const number = key.replace("name", "");
                  const subject = t(techItem.analysis[`subject${number}`], `❌ Missing Subject`);
                  const nameTranslated = t(value, `❌ Missing Name`);
                  const descriptionTranslated = t(techItem.analysis[`description${number}`], `❌ Missing Description`);
                  const roleTranslated = t(techItem.analysis[`role${number}`], `❌ Missing Role`);

                  console.log(`🔡 Tech ${number} Name:`, nameTranslated);
                  console.log(`📝 Tech ${number} Description:`, descriptionTranslated);
                  console.log(`🎭 Tech ${number} Role:`, roleTranslated);

                  return (
                    <li key={index} className="single-award-list">
                      <span className="award-year">{subject}</span>
                      <div className="award-details">
                        <h4>{nameTranslated}</h4>
                        <p>{descriptionTranslated}</p>
                      </div>
                      <span className="award-tag">{roleTranslated}</span>
                    </li>
                  );
                }
                return null;
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
